'use strict';

require('../components/jquery-zoom');

/**
 * @function resetPinchZoom
 * @description This function is used to reset the pinch-zoomed image to its original size
 *
 * @param {Object} element DOM object reference of pinch-zoom element.
 */
function resetPinchZoom(element) {
    element.setTransform({
        scale: 1,
        x: 0,
        y: 0
    });
}

/**
 * @function doubleTapPinchZoomHandler
 * @description This function is used to detect double tap on mobile devices and
 * reset the pinch-zoomed image to its original size
 *
 * @returns {Function} detectDoubleTap for every slide in carousel.
 */
function doubleTapPinchZoomHandler() {
    let lastTap = 0;
    let timeout;

    return function detectDoubleTap(event) {
        const curTime = new Date().getTime();
        const tapLen = curTime - lastTap;
        if (tapLen < 500 && tapLen > 100) {
            resetPinchZoom(event.currentTarget);
            event.preventDefault();
        } else {
            timeout = setTimeout(() => {
                clearTimeout(timeout);
            }, 100);
        }
        lastTap = curTime;
    };
}

/**
 * pdp modal for pinch zoom
 */
function zoomModalCall() {
    /**
    * zoom mobile function
    * @param {number} index - Response from the variation attributes API.
    */
    function mobileZoom(index) {
        if ($(window).width() <= 991) {
            var $zoomModalBody = $('#zoommodal .modal-body');
            var primaryImages = $('.primary-images').clone();
            var $videoElem = primaryImages.find('.carousel-video');
            $videoElem.remove();
            var selectedIndex = index || primaryImages.find('.carousel-item.active').index();
            primaryImages.find('.carousel-inner-zoom').find('.carousel-item').removeClass('col-6 p-3 active').addClass('carousel-item');
            primaryImages.find('.carousel-inner-zoom').find('.carousel-item').eq(+selectedIndex).addClass('active');
            primaryImages.find('.carousel-inner.carousel-desktop').not('.carousel-inner-zoom').remove();
            primaryImages.find('.carousel-inner.carousel-desktop.carousel-inner-zoom').removeClass('d-none');
            var mobileContent = primaryImages.html();

            $zoomModalBody.empty();
            $zoomModalBody.append('<div class="mobile-zoom d-flex align-items-center"></div>');
            $('#zoommodal .modal-body .mobile-zoom').append(mobileContent);

            var $document = $(document);

            $document.find('#zoommodal .modal-body img').removeAttr('data-toggle');
            var $carousel = $document.find('#zoommodal .carousel');
            $carousel.attr({ id: 'zoom-modal', 'data-touch': false });
            $carousel.addClass('w-100');
            $document.find('#zoommodal .modal-body').addClass('h-100');
            var noOfImages = $('.carousel-inner-zoom:not(.d-none)').find('.carousel-item.zoom-image-js').length;
            if (noOfImages > 1) {
                var prevBtn = $('<button>', {
                    class: 'carousel-control-prev',
                    href: '#' + $carousel.attr('id'),
                    type: 'button',
                    'data-label': 'prev',
                    'data-slide': 'prev'
                });
                $carousel.append(prevBtn);
                $('<span class="sr-only">Previous</span>').appendTo($($carousel).find('.carousel-control-prev'));
                var nextBtn = $('<button>', {
                    class: 'carousel-control-next',
                    href: '#' + $carousel.attr('id'),
                    type: 'button',
                    'data-label': 'next',
                    'data-slide': 'next'
                });
                $carousel.append(nextBtn);
                $('<span class="sr-only">Next</span>').appendTo($($carousel).find('.carousel-control-next'));
            }

            var $carouselIndicator = $document.find('#zoom-modal .carousel-indicators li');
            if ($videoElem.length) {
                $carouselIndicator.last().remove();
            }
            $carouselIndicator.attr('data-target', '#zoom-modal');
            $carouselIndicator.removeClass('active');
            $carouselIndicator.eq(+index).addClass('active');
            $('#zoommodal .thumb-image .thumbnail img').each(function () {
                $(this).removeAttr('data-target');
                $(this).removeAttr('data-toggle');
            });

            if ($('#zoommodal .carousel-item').length) {
                /* Regex test to determine if user is on mobile */
                if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                    $('#zoommodal .carousel-item').each(function () {
                        $(this).find('pinch-zoom').on('touchend', doubleTapPinchZoomHandler());
                    });
                    $carousel.on('slide.bs.carousel', function (slidIndex) {
                        var pinchZoolEle = $($(this).find('.carousel-item')[slidIndex.from]).find('pinch-zoom')[0];
                        if (pinchZoolEle) {
                            resetPinchZoom(pinchZoolEle);
                        }
                    });
                }
            }
        }
    }
    mobileZoom();

    /**
    * zoom plugin call
    */
    function zoomImage() {
        $('.modal .large-image .zoom-image-js').zoom({ on: 'toggle' });
    }

    $('body').on('click', '.modal .large-image .zoom-image-js img.zoomImg', function (e) {
        e.preventDefault();
        $(this).toggleClass('zoom-out');
    });

    /**
    * zoom desktop modal
    */
    function zoomModal() {
        if ($(window).width() > 991) {
            $('pinch-zoom').each(function () {
                var pinchElement = $(this);
                pinchElement.replaceWith($(pinchElement.html()));
            });
        }
        window.requestAnimationFrame(function () {
            var thumbImagesWrapper = $('.carousel-inner-zoom').clone();
            thumbImagesWrapper.find('.carousel-video').remove();
            var thumbImages = thumbImagesWrapper.html();

            /**
            * zoom desktop fill modal
            */
            function getModalHtmlElement() {
                if ($('#zoommodal').length !== 0) {
                    $('#zoommodal').remove();
                }
                var htmlString = '<!-- Modal -->'
                    + '<div class="modal zoom-modal fade" id="zoommodal" tabindex="-1" role="dialog">'
                    + '<span class="enter-message sr-only" ></span>'
                    + '<div class="modal-dialog zoommodal-dialog">'
                    + '<!-- Modal content-->'
                    + '<div class="modal-content">'
                    + '<div class="modal-header b-0">'
                    + '    <button aria-label="close" type="button" class="close" data-dismiss="modal">'
                    + '        <span aria-hidden="true">&times;</span>'
                    + '    </button>'
                    + '</div>'
                    + '<div class="modal-body p-0 "><div class="large-image"></div><div class="thumb-image"></div></div>'
                    + '</div>'
                    + '</div>'
                    + '</div>';
                $('body').append(htmlString);
            }
            getModalHtmlElement();

            // This section builds the zoom gallery
            $('.primary-images .carousel-inner button').each(function () {
                $(this).on('click', function () {
                    var dataIndex = $(this).find('img').attr('data-index');
                    var count = +dataIndex + 1;
                    var $modalLargeImage = $('#zoommodal .modal-body .large-image');
                    // This is the container for the zoom modal thumbnails
                    var $modalThumbImage = $('#zoommodal .modal-body .thumb-image');
                    mobileZoom(parseInt(dataIndex, 10));
                    window.requestAnimationFrame(function () {
                        $(document).find('#zoom-modal').carousel({ touch: false });
                    });
                    $modalLargeImage.empty();
                    $modalThumbImage.empty();
                    $modalLargeImage.append(thumbImages);
                    $modalThumbImage.append(thumbImages);

                    // Remove the unneeded picture element around the thumbnail images
                    $('#zoommodal .thumb-image .carousel-item.zoom-image-js picture').contents().unwrap();
                    // Remove the anchor tags around the thumbnail images and large image container
                    $('#zoommodal .thumb-image .carousel-item.zoom-image-js a').contents().unwrap();
                    $('#zoommodal .large-image .carousel-item.zoom-image-js a').contents().unwrap();

                    $('#zoommodal .modal-body .thumb-image img').wrapAll('<div class="thumbnail"></div>');
                    $('#zoommodal .thumb-image .thumbnail img').each(function () {
                        $(this).removeAttr('data-target');
                        $(this).removeAttr('data-toggle');
                        $(this).wrap('<button></button>');
                    });
                    $('#zoommodal .thumb-image img[data-index=' + dataIndex + ']').addClass('active');
                    $('#zoommodal .large-image img[data-index=' + dataIndex + ']').first().addClass('active');
                    $('#zoommodal .large-image .carousel-item:nth-child(' + count + ')').addClass('active zoom-in');
                    $('#zoommodal .thumb-image .zoom-image-js').first().addClass('active');
                    $modalLargeImage.removeClass('active').first().addClass('active zoom-in');
                    zoomImage();
                });
            });
        });
    }
    zoomModal();

    // Adding accessibility keyboard handler for carousel indicators
    $('ol.carousel-indicators').on('keyup', function (e) {
        if (e.key === 'Enter' && $(window).width() < 991 && e.target.tagName.toLowerCase() === 'ol') {
            const foundElement = $(e.target.parentElement).find('.carousel-item.zoom-image-js.active img');
            foundElement[0].click();
        }
    });

    // This event handler - enables the thumbnail to switch the currently zoomed image
    $(document).on('click', '#zoommodal .thumb-image .thumbnail button', function () {
        var imgIndex = $('#zoommodal .thumb-image .thumbnail button').index(this);
        var count = imgIndex + 1;
        // Toggling the red border on the thumbnails
        $('#zoommodal .thumb-image .thumbnail button img').removeClass('active');
        $(this).children().addClass('active');
        // These lines toggle the active class on the large zoomed image
        $('#zoommodal .large-image .carousel-item').removeClass('active zoom-in');
        $('#zoommodal .large-image .carousel-item:nth-child(' + count + ')').addClass('active zoom-in');
    });

    $(window).resize(function () {
        mobileZoom();
    });
} zoomModalCall();

module.exports = {
    zoomModalCall: zoomModalCall
};
